const storageKey = (organizationId: number) => `provisium.market.activeVenue:${organizationId}`

export const loadActiveVenueId = (organizationId: number): number | null => {
  try {
    const raw = localStorage.getItem(storageKey(organizationId))
    if (!raw) {
      return null
    }
    const parsed = Number(raw)
    return Number.isFinite(parsed) && parsed > 0 ? parsed : null
  } catch {
    return null
  }
}

export const saveActiveVenueId = (organizationId: number, venueId: number) => {
  localStorage.setItem(storageKey(organizationId), String(venueId))
}

export const clearActiveVenueId = (organizationId: number) => {
  localStorage.removeItem(storageKey(organizationId))
}
